<template>
    <div>
        <v-row v-if="this.$parent.reference" no-gutters>
            <div v-if="this.$parent.reference['Type__c'] !== 'Primary Guardian'" class="greeting-message">
                Hello {{this.$parent.reference['FirstName']}}. <br> 
                Thank you for providing a reference for <b>{{this.$parent.reference['GO_Scholar__c.Name']}}</b>’s GO-PEF {{this.$parent.scholarship ? this.$parent.scholarship.Name : ''}} application at {{this.$parent.reference['School__c']}}. <br> <br>
                Please review the scholarship and criteria below and click <b>Start Reference</b> to begin.
            </div>     
            <div v-else class="greeting-message">
                Hello {{this.$parent.reference['FirstName']}}. <br> 
                Thank you for supporting <b>{{this.$parent.reference['GO_Scholar__c.Name']}}</b>’s GO-PEF {{this.$parent.scholarship ? this.$parent.scholarship.Name : ''}} application at {{this.$parent.reference['School__c']}}. <br> <br>
                Please review the scholarship and criteria below and click <b>Start Declaration</b> to begin.
            </div>              
        </v-row>
        <v-row justify="center" no-gutters>
            <v-col md="10" sm="12">
                <ScholarshipCard v-if="this.$parent.scholarship" :detail="this.$parent.scholarship" :goToReference="goToRefernce" :type="this.$parent.type" />
            </v-col>
        </v-row>
        <ScholarshipCriteria/>
    </div>
</template>
<script>
import ScholarshipCard from '../ScholarshipComponent';
import ScholarshipCriteria from '../ScholarshipCriteriaComponent';


export default {
    components:{
        ScholarshipCard,
        ScholarshipCriteria
    },
    methods: {
        goToRefernce(){
            const toUrl = this.$parent.type == 'guardian' ? 'guardian.1' : `reference.${this.$parent.type}`
            this.$router.push({
                    name: toUrl
                });
        }
    },
}
</script>
<style lang="scss" scoped>

.greeting-message
{
  width: 940px;
  font-family: Hind;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: normal;
  text-align: center;
  color: black;
  margin: auto;
}
</style>